import { useMemo } from 'react'
import { differenceInDays } from 'date-fns/esm'
import { IOpportunity } from '@user/store/opportunity'
import { BulkActionsProps } from '@user/components/xGrid'
import { currencyString } from '@sales-center/common'

export const useBulkActionLabels = (
  selectedRows: BulkActionsProps['selectedRows'],
) => {
  const [avgAge, totalValue] = useMemo(() => {
    const rows = [...selectedRows.entries()]
    const today = new Date()

    const { totalAge, totalValue } = rows.reduce(
      ({ totalAge, totalValue }, [, row]) => {
        const opp = row as IOpportunity
        return {
          totalAge:
            totalAge + differenceInDays(today, new Date(opp.createdDate)),
          totalValue: totalValue + opp.totalValue,
        }
      },
      { totalAge: 0, totalValue: 0 },
    )

    const avgAge = Math.floor(totalAge / rows.length)

    return [
      `Average Age: ${avgAge} ${avgAge === 1 ? 'day' : 'days'}`,
      `Total Value: $${currencyString(totalValue)}`,
    ]
  }, [selectedRows])

  return { avgAge, totalValue }
}
